import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import { AiOutlineArrowRight } from "react-icons/ai";
import { useEffect } from "react";

import IndoWomenPowerAccordion from "./IndoWomenPowerAccordion";
import { question } from "./IndoWomenPowerData";

const IndoWomenPowerLoan = () => {
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo%20Women%20Power%20Loan.png";
  const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo%20Women%20Power%20Loan_Cover.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "The Women Power Loan is designed to support women in starting new enterprises or scaling existing businesses in manufacturing, trading, services, or agriculture-allied sectors. For non-individual businesses, at least 51% shareholding and controlling stake must be held by a woman entrepreneur.";

  return (
    <>
      <Breadcrumb
        Heading="Indo Women Power Loan"
        img={BackgroundBrundcrumb}
        show={true}
        btnTxt="Apply Now"
      />
      <SavePlusAccountComponent
        heading="Indo Women Power Loan"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      <section
        className="page-contains-area"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-contains-box">
                <div className="page-contains-btn">
                  <ul className="navigation clearfix scroll-nav">
                    <li className="current">
                      <a href="#IndoWomenPowerAccordion">
                        <img src={Arrow_down} className="me-1" />
                        Eligibility & Requirements
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="IndoWomenPowerAccordion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box my-5">
              {question.map((item) => {
                const { id } = item;
                return <IndoWomenPowerAccordion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>

      <div className="container">
        <div
          className="bg-light my-3"
          style={{
            padding: "20px 0px 20px 60px",
          }}
        >
          <h6 style={{ color: "#9E1B1E" }}>Terms and Conditions Apply</h6>
        </div>
      </div>
      <AllAcountsSection />
    </>
  );
};

export default IndoWomenPowerLoan;
